import { call, put, takeLatest } from 'redux-saga/effects';

import {
	FETCH_REFERRER_PATIENTS,
	FETCH_REFERRER_PENDING,
} from './constants';
import {
	fetchReferrerPatientsSuccess,
	fetchReferrerPatientsError,
	fetchReferrerPendingSuccess,
	fetchReferrerPendingError,
} from './actions';
import {
	fetchReferrerPatientsApi,
	fetchReferrerPendingApi,
} from './api';

function* fetchPatientsSaga(action) {
	try {
		const response = yield call(fetchReferrerPatientsApi, action.page);
		yield put(fetchReferrerPatientsSuccess(response.data));
	} catch (err) {
		yield put(fetchReferrerPatientsError(err));
	}
}

function* fetchPendingSaga() {
	try {
		const response = yield call(fetchReferrerPendingApi);
		yield put(fetchReferrerPendingSuccess(response.data));
	} catch (err) {
		yield put(fetchReferrerPendingError(err));
	}
}

export default function* referrerDashboardSaga() {
	yield takeLatest(FETCH_REFERRER_PATIENTS, fetchPatientsSaga);
	yield takeLatest(FETCH_REFERRER_PENDING, fetchPendingSaga);
}
